import { Subscription } from '../../@types'
import { apiFetcher } from '../../lib/fetcher/api'

interface BaseSubscriptionApiResponse {
  ok: boolean
  subscription?: Subscription
  message: string
  errorCode?: string
}

interface GetSubscriptionResponse extends BaseSubscriptionApiResponse {
  cached?: boolean
}

export const subscriptionService = {
  getSubscription: async (patientId: number, id: number) => {
    return apiFetcher<GetSubscriptionResponse>(`/patients/${patientId}/subscription/${id}/`, {
      auth: true,
    })
  },

  subscribe: async (
    patientId: number,
    payload: { sessionId: string; planId?: number; lab?: string; promoCode?: string }
  ) => {
    return apiFetcher<BaseSubscriptionApiResponse>(`/patients/${patientId}/subscription/subscribe`, {
      auth: true,
      method: 'POST',
      body: JSON.stringify({ ...payload }),
    })
  },

  unsubscribe: async (patientId: number, payload: { cancelAtPeriodEnd: boolean }) => {
    return apiFetcher<BaseSubscriptionApiResponse>(`/patients/${patientId}/subscription/unsubscribe`, {
      auth: true,
      method: 'POST',
      body: JSON.stringify({ ...payload }),
    })
  },
}
